import { Input, OnChanges, OnInit, SimpleChanges, Directive } from '@angular/core';
import { ColumnFieldType, ColumnFieldTypeObject, IColumnPk } from 'webcommon/shared';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class ApColumnBase<T extends ColumnFieldTypeObject> implements OnInit, OnChanges {
  @Input() baseId: string;
  @Input() columnName: string;
  @Input() dataItem: IColumnPk;
  @Input() columnInfoDto: T;

  Id: string;

  ngOnInit() {
    this.baseLoad();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.columnInfoDto || changes.dataItem) {
      this.baseLoad();
    }
  }

  private baseLoad() {
    this.setId();
    this.load();
  }

  protected setId() {
    this.Id = `${this.baseId}-row-${this.dataItem.Pk}-column-${this.columnName}`;
  }

  protected abstract load(): void;

  get ColumnFieldTypes() {
    return ColumnFieldType;
  }
}
